<template>
    <PublicPageLayout :heading="heading">
        <p>{{ message }}</p>
    </PublicPageLayout>
</template>

<script>
import PublicPageLayout from './components/PublicPageLayout.vue'

export default {
    name: 'InvalidInvite',
    components: { PublicPageLayout },
    computed: {
        heading() {
            return this.$t('§public.invalid_invite_heading')
        },
        message() {
            return this.$t('§public.invalid_invite_message')
        },
    },
}
</script>
